import { render, staticRenderFns } from "./ForInvoice.vue?vue&type=template&id=2a8df830&"
import script from "./ForInvoice.vue?vue&type=script&lang=js&"
export * from "./ForInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports